import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import sweetAlert, {
    sweetStatusAlert,
    sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import { passageTypeService } from "../../../service/question/passageTypeService.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../components/admin/css/common.css";
import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    Tooltip
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import config from '../../../helper/config.js';
import { customerConstants } from "../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import "./ManagePassageTypes.css";
import CardHeader from "../../../components/common/CardHeader.js";
import TabList from "../../../components/common/tabs/TabList.js";
import NavItem from "../../../components/common/tabs/NavItem.js";

const getCustomerFeatureFlag = () => {
    return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
        break;
    case customerConstants.EXO_CUSTOMER2:
        closeBtnStyle = {
            color: "var(--maincolor-cmc)",
            backgroundColor: "#E5F5FF",
            borderColor: "transparent",
        };
        addBtnStyle = {
            color: "#fff",
            backgroundColor: "var(--maincolor-cmc)",
            borderColor: "transparent",
        };
        break;
    default:
        break;
}

export default class ManagePassageTypes extends Component {
    constructor(props) {
        super(props);
        this.createValidationsInstance();
        this.state = {
            showModal: false,
            passageTypes: [],
            name: "",
            description: "",
            passage_type_id: "",
            modalType: false,
            search_val: "",
            isLoading: true,
            isSpinnerLoading: false,
            isModified: false,
            limit: 10, // Set the desired limit
            offset: 0, // Set the desired offset
            search_term: "",
            sort_column: "passage_type_id",
            sort_direction: "ASC",
            totalPassageTypes: 10,
            currentPage: 0,
            editVisibility: true,
            addVisibility: true,
            deleteVisibility: true,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEditSubmit = this.handleEditSubmit.bind(this);

        // Debounced version of handleSearch function
        this.debouncedHandleSearch = debounce(this.fetchAllPassageTypeData, 2000);
    }

    resetFormFields = () => {
        this.setState({
            name: "",
            description: "",
        });
    };

    componentDidMount() {
        this.fetchAllPassageTypeData();
    }

    createValidationsInstance() {
        this.validator = new SimpleReactValidator();
    }

    fetchAllPassageTypeData() {
        const { limit, offset, search_term, sort_column, sort_direction } = this.state;
        passageTypeService.getAll(limit, offset, search_term, sort_column, sort_direction)
            .then((response) => {
                if (response.success) {
                    this.setState({
                        passageTypes: response.data.passage_types,
                        totalPassageTypes: parseInt(response.data.total_count),
                    });
                } else {
                    sweetStatusAlert(
                        "Failed!",
                        "Error fetching passage types. Please refresh the screen!",
                        "error"
                    );
                }
            })
            .catch((error) => {
                sweetStatusAlert(
                    "Failed!",
                    "Error fetching passage types. Please refresh the screen!",
                    "error"
                );
            })
            .finally(() => {
                this.setState({ isLoading: false, isSpinnerLoading: false });
            });
    }

    handlePageChange = (event, newPage) => {
        const { limit } = this.state;
        const newOffset = newPage * limit;
        this.setState(
            {
                offset: newOffset,
                isLoading: true,
                currentPage: newPage,
            },
            () => {
                this.fetchAllPassageTypeData();
            }
        );
    };

    handleSortChange = (sort_column) => {
        // If the same column is clicked, toggle the sort direction
        const { sort_column: currentSortColumn, sort_direction } = this.state;
        const newSortDirection =
            currentSortColumn === sort_column && sort_direction === "ASC"
                ? "DESC"
                : "ASC";

        this.setState(
            {
                sort_column,
                sort_direction: newSortDirection,
                offset: 0, // Reset offset when changing sorting
                currentPage: 0,
                isLoading: true,
            },
            () => {
                this.fetchAllPassageTypeData();
            }
        );
    };

    handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
            {
                offset: newOffset,
                isLoading: true,
                currentPage: newPage
            },
            () => {
                this.fetchAllPassageTypeData();
            }
        );
    };

    handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.offset / newLimit);
        this.setState(
            {
                limit: newLimit,
                offset: newLimit * newPage,
                isTableDataLoading: true,
                currentPage: newPage,
            },
            () => {
                this.fetchAllPassageTypeData();
            }
        );
    };

    handleSearch = (event) => {
        const search_term = event.target.value.trim();
        const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

        if (search_term === "" || regex.test(search_term)) {
            this.setState(
                {
                    search_term,
                    isLoading: true,
                    offset: 0,
                    currentPage: 0,
                    searchError: false,
                },
                () => {
                    this.debouncedHandleSearch();
                }
            );
        } else {
            this.setState({ search_term, searchError: true });
        }
    };

    togglePassageTypeModal = (modalType) => {
        this.modalType = modalType;
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
        }));
    };

    toggleUpdatePassageTypeModal = (name, description, passage_type_id, modalType) => {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
            name: name,
            description: description,
            passage_type_id: passage_type_id,
            modalType: modalType,
        }));
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(() => ({ [name]: value, isModified: true }));
    };

    handleSweetAlert = (modalType, modalVisibility) => {
        if (this.state.isModified) {
            sweetAlert().then((response) => {
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.modalType = false;
                this.setState(() => ({
                    [modalVisibility]: response,
                    isModified: false,
                }));
            });
        } else {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            if (modalType) this.togglePassageTypeModal(false);
            else this.toggleUpdatePassageTypeModal();
        }
    };

    //Handle Edit Submit
    handleEditSubmit = (event) => {
        event.preventDefault();

        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
        }
        else {
            this.setState({ isSpinnerLoading: true });
            let created_by = sessionStorage.getItem("manage_user_id");
            const passageTypeItem = {
                name: this.state.name,
                description: this.state.description,
                created_by: created_by
            };
            const passageTypeId = this.state.passage_type_id;

            passageTypeService.updatePassageType(passageTypeItem, passageTypeId)
                .then((response) => {
                    if (response.success) {
                        this.setState({ isSpinnerLoading: false });
                        this.togglePassageTypeModal();
                        sweetStatusAlert(
                            "Success!",
                            "Passage type information updated successfully!",
                            "success"
                        );
                        this.validator.hideMessages();
                        this.validator.purgeFields();
                        this.resetFormFields();
                        this.fetchAllPassageTypeData();
                    } else {
                        this.setState({ isSpinnerLoading: false });
                        sweetStatusAlert("Failed!", response.message, "error");
                    }
                })
                .catch((error) => {
                    this.setState({ isSpinnerLoading: false });
                    sweetStatusAlert(
                        "Failed!",
                        "Unable to update the passage type information",
                        "error"
                    );
                });
        }
    };

    //add new Passage Type
    handleSubmit = (event) => {
        event.preventDefault();

        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
        }
        else {
            let created_by = sessionStorage.getItem("manage_user_id");
            this.setState({ isSpinnerLoading: true });
            const { name, description } = this.state;
            const newPassageTypeItem = { name: name, description: description, created_by: created_by };

            passageTypeService.addPassageType(newPassageTypeItem)
                .then((response) => {
                    if (response.success) {
                        sweetStatusAlert("Success!", response.message.success, "success");
                        this.validator.hideMessages();
                        this.validator.purgeFields();
                        this.resetFormFields();
                        this.togglePassageTypeModal(false);
                        this.fetchAllPassageTypeData();
                    } else {
                        this.setState({ isSpinnerLoading: false });
                        sweetStatusAlert("Failed!", response.message, "error");
                    }
                })
                .catch((err) => {
                    this.setState({ isSpinnerLoading: false });
                    sweetStatusAlert("Failed!", "Unable to create new passage type", "error");
                });
        }
    };

    handleDeletePassageType = (id) => {
        sweetConfirmAlert().then(() => {
            this.setState({ isSpinnerLoading: true });
            passageTypeService.deletePassageType(id)
                .then((response) => {
                    this.setState({ isSpinnerLoading: false });
                    if (response.success) {
                        sweetStatusAlert("Success!", response.message.success, "success");
                        this.fetchAllPassageTypeData();
                    } else {
                        sweetStatusAlert("Failed!", response.message, "error");
                    }
                })
                .catch((error) => {
                    this.setState({ isSpinnerLoading: false });
                    sweetStatusAlert("Oops!", "Error while deleting the passage type", "info");
                });
        });
    };

    render() {
        const {
            limit,
            passageTypes,
            totalPassageTypes,
            isLoading,
            currentPage,
            isSpinnerLoading,
            editVisibility,
            addVisibility,
            deleteVisibility,
        } = this.state;
        return (
            <>
                <div className="passage-types-container">
                    <CardHeader>
                        <div className="d-flex align-items-center w-100 flex-nowrap">
                            <div className="flex-grow-1">
                                <h3 className="text-nowrap mb-2">Question Passage Types</h3>
                            </div>

                            {addVisibility && (
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="btn w-auto btn-clean d-inline-flex align-items-center create-btn big-action-btn passage-add-btn"
                                        onClick={() => this.togglePassageTypeModal(true)}
                                    >
                                        <span className="btn btn-link-primary font-weight-bolder font-size-base text-nowrap">Add Passage Type</span>
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="passage-top-controls-grid">

                            {/* Inline nav tabs copy (shows inside the controls grid for Manage Passage Types) */}
                            <div className="passage-tabs-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                                <TabList>
                                    <NavItem
                                        className={`nav-link ${this.props.activeTab === 'Passage Types' ? 'active' : ''}`}
                                        id="passage-types-tab-1-grid"
                                        href="#passage-types-1"
                                        dataToggle="tab"
                                        iconName="flaticon2-list-2"
                                        tabName="Passage Types"
                                        onClick={() => (this.props.setActiveTab ? this.props.setActiveTab('Passage Types') : null)}
                                    />
                                    <NavItem
                                        className={`nav-link ${this.props.activeTab === 'Passages' ? 'active' : ''}`}
                                        id="passages-tab-1-grid"
                                        href="#passages-1"
                                        dataToggle="tab"
                                        iconName="flaticon2-file"
                                        tabName="Passages"
                                        onClick={() => (this.props.setActiveTab ? this.props.setActiveTab('Passages') : null)}
                                    />
                                </TabList>
                            </div>




                            {/* 2. Search Field - Middle Left */}
                            <div className="passage-search-wrapper">
                                <Form.Group controlId="exampleForm.ControlInput1" className="mb-0">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search"
                                        onChange={this.handleSearch}
                                        isInvalid={this.state.searchError}
                                        className="w-100"
                                    />
                                </Form.Group>
                            </div>

                            {/* 3. Number of Passage Types - Middle Right */}
                            <div className="passage-count-wrapper">
                                <div className="sort-button no-of-items">
                                    <span className="sort-by-label">Total Types</span>
                                    <span className="sort-current">
                                        {isLoading ? (
                                            <CircularProgress size={16} />
                                        ) : (
                                            totalPassageTypes
                                        )}
                                    </span>
                                </div>
                            </div>

                            {/* 4. Sort Dropdown - Right Edge */}
                            <div className="passage-sort-wrapper">
                                <Dropdown className="sort-dropdown">
                                    <Dropdown.Toggle
                                        variant="light"
                                        id="sort-dropdown"
                                        className={`sort-button ${this.state.sort_direction === 'DESC' ? 'desc' : ''}`}
                                    >
                                        <span className="sort-by-label">Sort By:</span>
                                        <span className="sort-current">
                                            {this.state.sort_column === "passage_type_id" && "ID"}
                                            {this.state.sort_column === "name" && "Name"}
                                            {this.state.sort_column === "description" && "Description"}
                                        </span>
                                        {this.state.sort_direction === 'ASC' ? (
                                            <ArrowUpwardIcon sx={{ fontSize: 16, color: '#5458AF', marginLeft: '4px' }} />
                                        ) : (
                                            <ArrowDownwardIcon sx={{ fontSize: 16, color: '#5458AF', marginLeft: '4px' }} />
                                        )}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="sort-menu">
                                        <div className="menu-header">Sort By</div>
                                        <div className="menu-body">
                                            <Dropdown.Item
                                                active={this.state.sort_column === "passage_type_id"}
                                                onClick={() => this.handleSortChange("passage_type_id")}
                                            >
                                                ID
                                                {this.state.sort_column === "passage_type_id" && <span className="checkmark">✓</span>}
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                active={this.state.sort_column === "name"}
                                                onClick={() => this.handleSortChange("name")}
                                            >
                                                Name
                                                {this.state.sort_column === "name" && <span className="checkmark">✓</span>}
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                active={this.state.sort_column === "description"}
                                                onClick={() => this.handleSortChange("description")}
                                            >
                                                Description
                                                {this.state.sort_column === "description" && <span className="checkmark">✓</span>}
                                            </Dropdown.Item>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </CardHeader>

                    {/* Table Section */}
                    <div>
                        {isSpinnerLoading && (
                            <PageSpinner id="show" text="Loading, Please wait!" />
                        )}
                        {isLoading ? (
                            <div
                                className="loading-container"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    height: "60vh",
                                }}
                            >
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                            </div>
                        ) : passageTypes.length > 0 ? (
                            <>
                                {/* CARD VIEW */}
                                <div className="passage-cards-container">
                                    {passageTypes.map((passageTypeItem) => (
                                        <div key={`passage-type-card-${passageTypeItem.passage_type_id}`} className="passage-type-card">
                                            <div className="passage-card-content">
                                                {/* Left Section - ID, Name, Description */}
                                                <div className="passage-left-section">
                                                    <div className="passage-card-title-row">
                                                        <span className="passage-card-id">
                                                            #{passageTypeItem.passage_type_id}
                                                        </span>
                                                        <Tooltip
                                                            title={passageTypeItem.name}
                                                            placement="bottom-start"
                                                            arrow
                                                        >
                                                            <span className="passage-card-name">
                                                                {passageTypeItem.name}
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="passage-meta-info">
                                                        <span className="passage-description-text">
                                                            {passageTypeItem.description}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Right Section - Actions */}
                                                {(editVisibility || deleteVisibility) && (
                                                    <div className="passage-actions-group">
                                                        {editVisibility && (
                                                            <Tooltip title="Edit Details" placement="top" arrow>
                                                                <button
                                                                    className="passage-action-btn edit-btn flaticon-edit-icon"
                                                                    onClick={() =>
                                                                        this.toggleUpdatePassageTypeModal(
                                                                            passageTypeItem.name,
                                                                            passageTypeItem.description,
                                                                            passageTypeItem.passage_type_id,
                                                                            false
                                                                        )
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        {deleteVisibility && (
                                                            <Tooltip title="Delete" placement="top" arrow>
                                                                <button
                                                                    className="passage-action-btn delete-btn flaticon-delete"
                                                                    onClick={() =>
                                                                        this.handleDeletePassageType(
                                                                            passageTypeItem.passage_type_id
                                                                        )
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <MaterialCustomTablePagination
                                    totalCount={totalPassageTypes}
                                    currentPage={currentPage}
                                    limit={limit}
                                    handlePageChange={this.handlePageChange}
                                    handleRowsPerPageChange={this.handleRowsPerPageChange}
                                    handlePageOffsetChange={this.handlePageOffsetChange}
                                    offset={this.state.offset}
                                    rowsPerPageOptions={[5, 10, 20]}
                                />

                                {/* TABLE VIEW - COMMENTED OUT */}
                                {/* <div style={{ width: "100%", height: "60vh", overflow: "auto" }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="thead">No</TableCell>
                                                <TableCell className="thead">Name</TableCell>
                                                <TableCell className="thead">Description</TableCell>
                                                {(editVisibility || deleteVisibility) && (
                                                    <TableCell className="thead">Actions</TableCell>
                                                )}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {passageTypes.map((passageTypeItem) => (
                                                <TableRow key={passageTypeItem.passage_type_id}>
                                                    <TableCell className="tData">
                                                        {passageTypeItem.passage_type_id}
                                                    </TableCell>
                                                    <TableCell className="tData">
                                                        {passageTypeItem.name}
                                                    </TableCell>
                                                    <TableCell className="tData">
                                                        {passageTypeItem.description}
                                                    </TableCell>
                                                    {(editVisibility || deleteVisibility) && (
                                                        <TableCell>
                                                            <div className="btn-group">
                                                                {editVisibility && (
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.toggleUpdatePassageTypeModal(
                                                                                passageTypeItem.name,
                                                                                passageTypeItem.description,
                                                                                passageTypeItem.passage_type_id,
                                                                                false
                                                                            )
                                                                        }
                                                                        className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                                                        title="Edit Details"
                                                                    />
                                                                )}
                                                                {deleteVisibility && (
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.handleDeletePassageType(
                                                                                passageTypeItem.passage_type_id
                                                                            )
                                                                        }
                                                                        className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                                                        title="Delete"
                                                                    />
                                                                )}
                                                            </div>
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <MaterialCustomTablePagination
                                        totalCount={totalPassageTypes}
                                        currentPage={currentPage}
                                        limit={limit}
                                        handlePageChange={this.handlePageChange}
                                        handleRowsPerPageChange={this.handleRowsPerPageChange}
                                        handlePageOffsetChange={this.handlePageOffsetChange}
                                        offset={this.state.offset}
                                        rowsPerPageOptions={[5, 10, 20]}
                                    />
                                </div> */}
                            </>
                        ) : (
                            <div className="no-passage-types-container">
                                <div className="no-passage-types-inner">
                                    <i className="fas fa-inbox no-passage-types-icon" aria-hidden="true"></i>
                                    <span className="no-passage-types-text">No Passage Types Available!</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showModal}
                    onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
                >
                    {this.modalType === true ? (
                        <div>
                            <Modal.Header closeButton>
                                <Modal.Title>Create New Passage Type</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Row className="my-5">
                                        <Form.Group
                                            as={Col}
                                            md="6"
                                            controlId="exampleForm.ControlInput1"
                                        >
                                            <Form.Label>Name*</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Type name here..."
                                                value={this.state.name}
                                                onChange={this.handleChange}
                                            />
                                            {this.validator.message(
                                                "name",
                                                this.state.name,
                                                "required|alpha_space|max:60",
                                                {
                                                    className: "text-danger",
                                                    messages: {
                                                        max: "The passage type name should not be greater than 60 characters.",
                                                        required: "The passage type name field is required.",
                                                    },
                                                }
                                            )}
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            md="6"
                                            controlId="exampleForm.ControlInput1"
                                        >
                                            <Form.Label>Description*</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                type="text"
                                                name="description"
                                                placeholder="Type description here..."
                                                value={this.state.description}
                                                onChange={this.handleChange}
                                            />
                                            {this.validator.message(
                                                "description",
                                                this.state.description,
                                                "required|max:120",
                                                {
                                                    className: "text-danger",
                                                    messages: {
                                                        max: "The passage type description should not be greater than 120 characters.",
                                                        required: "The passage type description field is required.",
                                                    },
                                                }
                                            )}
                                        </Form.Group>
                                    </Row>
                                </Form>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    style={addBtnStyle}
                                    onClick={this.handleSubmit}
                                >
                                    Save changes
                                </Button>
                                <Button
                                    id="modal-close-button"
                                    style={closeBtnStyle}
                                    onClick={() =>
                                        this.handleSweetAlert(this.modalType, "showModal")
                                    }
                                >
                                    Close
                                </Button>
                            </Modal.Footer>
                        </div>
                    ) : (
                        <div>
                            <Modal.Header closeButton>
                                <Modal.Title>Update Passage Type</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Row className="my-5">
                                        <Form.Group
                                            as={Col}
                                            md="6"
                                            controlId="exampleForm.ControlInput1"
                                        >
                                            <Form.Label>Name*</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Type name here..."
                                                value={this.state.name ? this.state.name : ""}
                                                onChange={this.handleChange}
                                            />
                                            {this.validator.message(
                                                "name",
                                                this.state.name,
                                                "required|alpha_space|max:60",
                                                {
                                                    className: "text-danger",
                                                    messages: {
                                                        max: "The passage type name should not be greater than 60 characters.",
                                                        required: "The passage type name is required.",
                                                    },
                                                }
                                            )}
                                        </Form.Group>
                                        <Form.Group
                                            as={Col}
                                            md="6"
                                            controlId="exampleForm.ControlInput1"
                                        >
                                            <Form.Label>Description*</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                type="text"
                                                name="description"
                                                placeholder="Type description here..."
                                                value={this.state.description}
                                                onChange={this.handleChange}
                                            />
                                            {this.validator.message(
                                                "description",
                                                this.state.description,
                                                "required|max:120",
                                                {
                                                    className: "text-danger",
                                                    messages: {
                                                        max: "The passage type description should not be greater than 120 characters.",
                                                        required: "The passage type description field is required.",
                                                    },
                                                }
                                            )}
                                        </Form.Group>
                                    </Row>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    className="modal-btn"
                                    variant="primary"
                                    style={addBtnStyle}
                                    onClick={this.handleEditSubmit}
                                >
                                    Save changes
                                </Button>
                                <Button
                                    className="modal-btn"
                                    id="modal-close-button"
                                    style={closeBtnStyle}
                                    onClick={() =>
                                        this.handleSweetAlert(this.modalType, "showModal")
                                    }
                                >
                                    Close
                                </Button>
                            </Modal.Footer>
                        </div>
                    )}
                </Modal>
            </>
        );
    }
}
